export class Forms {

	constructor() {
		const typingButtonAnimation = document.querySelectorAll('.textbox-button input[type="text"]');

		typingButtonAnimation.forEach((elem) => {
			elem.addEventListener('keyup',
				(e) => {
					const target = e.target as HTMLFormElement;
					const button = target.parentNode.querySelector('button') as HTMLElement;
					if (button) {
						if (target.value === '') {
							button.classList.remove('typing');
						} else {
							button.classList.add('typing');
						}
					}

				});
		});
	}
}